import Datepicker from 'rctui/Datepicker';
import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'jsx!Component/I18n';

class DateTimeRangePicker extends React.Component {
  static displayName = 'DateTimeRangePicker';

  static defaultProps = {
    disabled: false,
    showPresets: false,
    name: '',
    value: { from: '', to: '' }
  };

  static propTypes = {
    name: PropTypes.string
  };

  presets = {
    today: -1,
    day3: -3,
    week: -7,
    month: -30,
  };

  constructor(props) {
    super(props);
    let x = new Date();
    this.utcOffset = x.getTimezoneOffset() * 60000;
  }

  setPreset = (preset, e) => {
    e.preventDefault();
    let value = Date.now() + this.presets[preset] * 86400000;
    let toValue = Date.now();
    this.props.onChange(this.props.name, { from: value, to: toValue });
  };

  timeToVal(value) {
    let outValue = value;
    if (outValue === undefined || outValue === null) {
      outValue = '';
    }

    return outValue;
  }

  timeToUTC(value) {
    let outValue = this.timeToVal(value);
    if (outValue !== '' && outValue !== 0) {
      outValue = value - this.utcOffset;
    }

    return outValue;
  }

  timeToLoc(value) {
    let outValue = this.timeToVal(value);
    if (outValue !== '' && outValue !== 0) {
      outValue = value + this.utcOffset;
    }

    return outValue;
  }

  onChangeFrom = (value) => {
    this.props.onChange(this.props.name, { from: this.timeToUTC(value), to: this.timeToVal(this.props.value.to) });
  };

  clearDate = () => {
    this.props.onChange(this.props.name, { from: '', to: '' });
  };

  onChangeTo = (value) => {
    this.props.onChange(this.props.name, { from: this.timeToVal(this.props.value.from), to: this.timeToUTC(value) });
  };

  render() {
    let presets = [];
    if (this.props.showPresets) {
      for (let preset in this.presets) {
        presets.push(<a href="#" onClick={(e) => this.setPreset(preset, e)} key={preset}><I18n
          message={"preset." + preset} /></a>);
      }
    }

    let from = this.timeToLoc(this.props.value.from);
    let to = this.timeToLoc(this.props.value.to);

    let presets_bar = <div className="time_range_presets">{presets}</div>;

    return (
      <div>
        {presets_bar}
        <Datepicker format='dd-MM-yyyy, hh:mm:ss' onChange={this.onChangeFrom} unixtime value={from} className={this.props.className} />
        <Datepicker format='dd-MM-yyyy, hh:mm:ss' onChange={this.onChangeTo} unixtime value={to} className={this.props.className} />
        <button onClick={this.clearDate}>Clear</button>
      </div>
    );
  }
}

export default DateTimeRangePicker;



// WEBPACK FOOTER //
// ./src/js/Component/DateTimeRangePicker.jsx